import React from 'react';

const Quote = () => (
  <div className=" pageContainer text-center">
    <p style={{ fontFamily: 'Tangerine', fontSize: '2.5em' }}>
      &quot;Mathematics is not about numbers, equations, computations,
      or algorithms: it is about understanding.&quot;
    </p>
    <span>- Willian Paul Thurtson</span>
  </div>
);

export default Quote;
